import { OKTA_BODY_ATTRIBUTE_NAME } from './constants';

export function isOktaEnalbed() {
    return document.body.getAttribute(OKTA_BODY_ATTRIBUTE_NAME) === 'enabled';
}
